export default __webpack_public_path__ + "static/media/bbl.6cd07064.svg";